export default "__VITE_PUBLIC_ASSET__110e2075__"